import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { constructRestUrl } from '@util/url';

@Injectable()
export class ValdrConstraintsRestService {

  constructor(private http: HttpClient) {}

  fetchValdrConstraints() {
    return this.http.get(constructRestUrl('constraints'));
  }

}
